module.exports = "https://web-assets-production.autolist.com/_next/static/images/content-promo-small-fb7581be9b7f0b9d8eda898947d193a3.svg";